/**
 * Вопросы и ответы в конце ленты.
 *
 * Пять вопросов, которые человек задаёт на самом деле: как участвовать, не
 * обман ли это, когда приз, сколько стоит и что будет с его данными. Не
 * «часто задаваемые» в смысле «удобные нам» — на неудобные тоже отвечаем, и
 * прямо: «это не лотерея», «участие бесплатное», «данные уходят бренду
 * только с твоего согласия».
 *
 * Разметка — обычные details: раскрытие работает без JavaScript, с
 * клавиатуры и в поиске по странице, а анимация тут только мешала бы читать.
 */
import { Icon } from '@allswipes/ui';
import { useLang } from '@allswipes/i18n';
import { Link } from 'react-router-dom';

import { sitePage } from '../site';

export function FeedFaq() {
  const { lang, t } = useLang();
  return (
    <section className="faq">
      <div className="faq-head">
        <span className="t">{t('Вопросы и ответы')}</span>
        <span className="n">{t('коротко и по делу')}</span>
      </div>

      <div className="faq-list">
        <details>
          <summary>
            {t('Как участвовать?')}
            <Icon name="chevronDown" size={14} />
          </summary>
          <p>
            {t('Найди код: под крышкой, на этикетке, в чеке или на полке — где именно, написано на странице акции. Отсканируй его в приложении: за розыгрыш ты получишь билет с номером, в мгновенной механике — результат сразу. Один код участвует один раз.')}
          </p>
          <p>
            <Link to="/scan">{t('Сканировать код')}</Link>
          </p>
        </details>

        <details>
          <summary>
            {t('Откуда мне знать, что розыгрыш честный?')}
            <Icon name="chevronDown" size={14} />
          </summary>
          <p>
            {t('Результат считает формула, а не человек. До розыгрыша публикуется список билетов, свёрнутый в хеш, и обещание сида; в день розыгрыша сид раскрывается — это публичный внешний источник, например тираж гослото, который организатор не выбирает. Дальше победители получаются пересчётом, и этот пересчёт можно повторить самому, прямо в браузере.')}
          </p>
          <p>
            <a href={sitePage('/about#fair', lang)} target="_blank" rel="noreferrer">
              {t('Как это проверяется')}
            </a>
          </p>
        </details>

        <details>
          <summary>
            {t('Когда и где я получу приз?')}
            <Icon name="chevronDown" size={14} />
          </summary>
          <p>
            {t('Мгновенные призы и баллы приходят сразу. Вещевой приз нужно оформить — на это даётся срок, он указан в правилах акции; дальше бренд готовит приз и выдаёт его в своей точке. Статус виден в «Моих участиях» на каждом шаге: оформлен, готов, получен.')}
          </p>
          <p>
            {t('Выдаёт приз бренд — он же организатор акции. Платформа следит за сроками и показывает, кто и что обещал.')}
          </p>
        </details>

        <details>
          <summary>
            {t('Это лотерея? Надо что-то платить?')}
            <Icon name="chevronDown" size={14} />
          </summary>
          <p>
            {t('Нет и нет. Это рекламные акции брендов: участие бесплатное, билет нельзя купить, а ставок здесь не бывает. Платформа не берёт денег с участников — за проведение акции платит бренд.')}
          </p>
        </details>

        <details>
          <summary>
            {t('Что будет с моими данными?')}
            <Icon name="chevronDown" size={14} />
          </summary>
          <p>
            {t('Почта нужна для входа — её брендам не передают. Анкету бренд может запросить, но только из закрытого списка полей и только с твоего подтверждения: ты видишь значения до передачи и можешь отказаться, код при этом не тратится. Кому и что ты передал, видно в профиле.')}
          </p>
          <p>
            <Link to="/profile">{t('Мои согласия')}</Link>
            <span className="dot">·</span>
            <a href={sitePage('/privacy', lang)} target="_blank" rel="noreferrer">
              {t('Политика данных')}
            </a>
          </p>
        </details>
      </div>
    </section>
  );
}
